import React, { Component } from 'react';
import { connect } from "react-redux";
import { Col, Grid, Image, Row } from 'react-bootstrap';
import { setData } from "../../redux/actionCreators";
import './rekognition_face_liveness_init.css';

class RekognitionFaceLivenessInit extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    console.log(this.props.stepInfo.redirectUrl, this.props.stepInfo.faceLivenessSuccess, this.props.stepInfo.faceLivenessAttempts);
    if (this.props.stepInfo.redirectUrl && !this.props.stepInfo.faceLivenessSuccess && this.props.stepInfo.faceLivenessAttempts) {
      window.location.assign(this.props.stepInfo.redirectUrl);
    } else if (typeof this.props.stepInfo.redirectUrl === 'undefined' && this.props.stepInfo.faceLivenessAttempts && !this.props.stepInfo.faceLivenessSuccess) {
      setTimeout(function() {
        window.location.reload();
      }, 2000);
    }
  }

  renderAlertMessage() {
    return (
      <>
        <Row>
          <Col xs={12}>
            <p className={'description'}>
              Serás redirigido a una serie de preguntas para validar tu identidad
            </p>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <div className='instruction-text'>
              Se ha agotado el número de reintentos de Firma avanzada. Para continuar debes responder unas
              preguntas de seguridad
            </div>
          </Col>
        </Row>
      </>
    );
  }

  renderMessage() {
    let text = '';
    let icon;
    if (this.props.stepInfo.signed) {
      text = 'Proceso completado exitosamente';
      icon = 'ok-circle.svg';
    } else {
      text = this.props.stepInfo.signatureAttempts ? 'Estás siendo redirigido a la plataforma de Reconocimiento facial' : 'Has superado el límite de reintentos posibles';
      icon = this.props.stepInfo.signatureAttempts ? 'loading.gif' : 'alert-icons/alert-icon-10.svg';
    }

    const messageIcon = require(`../../resources/images/${icon}`).default;
    return (
      <>
        <Row>
          <Col xs={12}>
            <p className={'description'}>
              {text}
            </p>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <div className="externImage">
              <Image src={messageIcon} />
            </div>
          </Col>
        </Row>
      </>
    );
  };

  renderButton() {
    if (this.props.stepInfo.signed) {
      return (
        <Button className={'next-button'} onClick={this.props.nextStep}>
          {this.props.buttonText}
        </Button>
      );
    }
  }

  render() {
    let data = this.props.data ? this.props.data : this.props.stepData;
    data = data ? data : {};
    return (
      <div className={'instruction-rekognition full-security'}>
        <Grid>
          <div className={'content'}>
            <div className={'break-top'}></div>
            <br />
            <br />
            <Row>
              <Col xs={12} >
                <h1 className={'title-rekognition'}>Reconocimiento facial</h1>
              </Col>
            </Row>
            <br />
            {this.props.stepInfo.signatureAttempts ? this.renderMessage() : ''}
            {this.renderButton()}
          </div>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    stepInfo: state.stepInfo,
    data: state.data,
    stepData: state.stepData,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setData: (data) => {
      dispatch(setData(data));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RekognitionFaceLivenessInit);
